__turbopack_context__.v({
  "burstCoin": "Ecosystem-module__lO09Ja__burstCoin",
  "coin": "Ecosystem-module__lO09Ja__coin",
  "coin1": "Ecosystem-module__lO09Ja__coin1",
  "coin2": "Ecosystem-module__lO09Ja__coin2",
  "coin3": "Ecosystem-module__lO09Ja__coin3",
  "container": "Ecosystem-module__lO09Ja__container",
  "fillTrack": "Ecosystem-module__lO09Ja__fillTrack",
  "fillTrackVert": "Ecosystem-module__lO09Ja__fillTrackVert",
  "flowStage": "Ecosystem-module__lO09Ja__flowStage",
  "header": "Ecosystem-module__lO09Ja__header",
  "iconWrapper": "Ecosystem-module__lO09Ja__iconWrapper",
  "moneyBurst": "Ecosystem-module__lO09Ja__moneyBurst",
  "node1": "Ecosystem-module__lO09Ja__node1",
  "node2": "Ecosystem-module__lO09Ja__node2",
  "node3": "Ecosystem-module__lO09Ja__node3",
  "node4": "Ecosystem-module__lO09Ja__node4",
  "nodeCard": "Ecosystem-module__lO09Ja__nodeCard",
  "nodePulse": "Ecosystem-module__lO09Ja__nodePulse",
  "nodesContainer": "Ecosystem-module__lO09Ja__nodesContainer",
  "progressLine": "Ecosystem-module__lO09Ja__progressLine",
  "section": "Ecosystem-module__lO09Ja__section",
  "trackLine": "Ecosystem-module__lO09Ja__trackLine",
  "travelPath": "Ecosystem-module__lO09Ja__travelPath",
  "traveler": "Ecosystem-module__lO09Ja__traveler",
  "travelerChange": "Ecosystem-module__lO09Ja__travelerChange",
  "travelerIcon": "Ecosystem-module__lO09Ja__travelerIcon",
});
